import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import hasProperty from "lodash/has";

function MultiSelectbox({
  id,
  name,
  onChange,
  errors,
  errorKey,
  classes = "",
  fieldValues = [],
  options = [],
  formErrorClass = "form-error"
}) {
  const [formError, setFormError] = useState("");
  const [formErrorMessage, setFormErrorMessage] = useState("");

  useEffect(() => {
    setFormError("");
    setFormErrorMessage("");

    if (
      hasProperty(errors, "response.data.data.errors") &&
      errors.response.data.data.errors.length > 0
    ) {
      for (const iterator of errors.response.data.data.errors) {
        if (iterator.field === errorKey) {
          setFormError(formErrorClass || "form-error");
          setFormErrorMessage(iterator.message);
        }
      }
    }
  }, [name, errorKey, errors, formErrorClass]);

  const onInputChange = () => {
    setFormError("");
    setFormErrorMessage("");
  };

  return (
    <>
      <select
        multiple
        id={id}
        name={name}
        value={fieldValues}
        className={`form-input ${classes} ${formError}`}
        onChange={e => {
          var options = e.target.options;
          var values = [];
          for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
              values.push(options[i].value);
            }
          }
          onInputChange(e);
          onChange(values);
        }}
      >
        {options.map((option, idx) => (
          <option key={idx} value={option.value}>
            {option.value}
          </option>
        ))}
      </select>
      {formErrorMessage && <div className={formError}>{formErrorMessage}</div>}
    </>
  );
}

MultiSelectbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  errorKey: PropTypes.string.isRequired, // The string that the api error returns in the "field" key
  classes: PropTypes.string,
  fieldValues: PropTypes.array,
  options: PropTypes.array,
  formErrorClass: PropTypes.string
};

export default MultiSelectbox;
